export const OHL = {
    name: 'DV 148/1',
    voltage: '110',
    regionCode: 'BR',
    stanice: [],
    stubovi: [
        { index: 1, name: 'P-06', lat: 44.0659 , lng: 22.1, sys: 1, portal: true },
        { index: 2, name: '1', lat: 44.066 , lng: 22.1009, sys: 1},
        { index: 3, name: '2', lat: 44.0655 , lng: 22.1025, sys: 1},
        { index: 4, name: '3', lat: 44.0642 , lng: 22.1065, sys: 1},
        { index: 5, name: '4', lat: 44.0635 , lng: 22.1086, sys: 1},
        { index: 6, name: '5', lat: 44.0625 , lng: 22.1115, sys: 1},
        { index: 7, name: '6', lat: 44.0618 , lng: 22.1138, sys: 1},
        { index: 8, name: '7', lat: 44.0608 , lng: 22.1147, sys: 1},
        { index: 9, name: '8', lat: 44.0589 , lng: 22.1167, sys: 1},
        { index: 10, name: '9', lat: 44.057 , lng: 22.1185, sys: 1},
        { index: 11, name: '10', lat: 44.0555 , lng: 22.1198, sys: 1},
        { index: 12, name: '11', lat: 44.0541 , lng: 22.121, sys: 1},
        { index: 13, name: '12', lat: 44.054 , lng: 22.122, sys: 1},
        { index: 14, name: 'P-04', lat: 44.0542 , lng: 22.1222, sys: 1, portal: true }
    ],
    rasponi: [
        { name: 'P-06 - 1', position: [{ lat: 44.0659 , lng: 22.1 }, { lat: 44.066 , lng: 22.1009 }] },
        { name: '1 - 2', position: [{ lat: 44.066 , lng: 22.1009 }, { lat: 44.0655 , lng: 22.1025 }] },
        { name: '2 - 3', position: [{ lat: 44.0655 , lng: 22.1025 }, { lat: 44.0642 , lng: 22.1065 }] },
        { name: '3 - 4', position: [{ lat: 44.0642 , lng: 22.1065 }, { lat: 44.0635 , lng: 22.1086 }] },
        { name: '4 - 5', position: [{ lat: 44.0635 , lng: 22.1086 }, { lat: 44.0625 , lng: 22.1115 }] },
        { name: '5 - 6', position: [{ lat: 44.0625 , lng: 22.1115 }, { lat: 44.0618 , lng: 22.1138 }] },
        { name: '6 - 7', position: [{ lat: 44.0618 , lng: 22.1138 }, { lat: 44.0608 , lng: 22.1147 }] },
        { name: '7 - 8', position: [{ lat: 44.0608 , lng: 22.1147 }, { lat: 44.0589 , lng: 22.1167 }] },
        { name: '8 - 9', position: [{ lat: 44.0589 , lng: 22.1167 }, { lat: 44.057 , lng: 22.1185 }] },
        { name: '9 - 10', position: [{ lat: 44.057 , lng: 22.1185 }, { lat: 44.0555 , lng: 22.1198 }] },
        { name: '10 - 11', position: [{ lat: 44.0555 , lng: 22.1198 }, { lat: 44.0541 , lng: 22.121 }] },
        { name: '11 - 12', position: [{ lat: 44.0541 , lng: 22.121 }, { lat: 44.054 , lng: 22.122 }] },
        { name: '12 - P-04', position: [{ lat: 44.054 , lng: 22.122 }, { lat: 44.0542 , lng: 22.1222 }] }
    ]
}
